const slugify = (value, { separator = '-' } = {}) =>
  value
    .replace(new RegExp(`[^A-Za-z0-9\\s${separator}]|^(\\s|${separator})`), '')
    .replace(' ', separator)
    .replace(new RegExp(`${separator}{2,}`), separator)
    .toLowerCase()

export const finalizeSlug = (value, { separator = '-' } = {}) =>
  value.replace(new RegExp(`${separator}$`), '')

export default slugify



// WEBPACK FOOTER //
// ./src/utils/slugify.js